module.exports = __webpack_public_path__ + "img/cross.65802a25.svg";